import { Box, IconButton } from "@mui/material";
import React from "react";

import { ThemeMode, useThemeContext } from "../../context/ThemeContext";

interface IProps {
  className?: string;
}

const ThemeSwitcher: React.FC<IProps> = ({ className }) => {
  const { mode, toggleTheme } = useThemeContext();

  return (
    <Box
      className={className}
      sx={{
        padding: "4px",
        display: "inline-flex",
        borderRadius: "4px",
        backgroundColor: mode === "dark" ? "#1F242A" : "#F0F0F0",
      }}
    >
      <IconButton
        size="small"
        sx={{
          padding: "4px",
          backgroundColor: mode === "light" ? "white" : "transparent",
          boxShadow:
            mode === "light" ? "0px 1px 4px rgba(0, 0, 0, 0.1)" : "none",
          borderRadius: "4px",
          opacity: mode === "light" ? 1 : 0.6,
          "&:hover": {
            backgroundColor:
              mode === "light" ? "white" : "rgba(255, 255, 255, 0.08)",
          },
        }}
        onClick={toggleTheme}
      >
        <svg
          fill="none"
          height="20"
          viewBox="0 0 16 16"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_18_410)">
            <path
              d="M8 0.833313C8.27613 0.833313 8.5 1.05717 8.5 1.33331V1.99998C8.5 2.27612 8.27613 2.49998 8 2.49998C7.72387 2.49998 7.5 2.27612 7.5 1.99998V1.33331C7.5 1.05717 7.72387 0.833313 8 0.833313Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M7.99996 4.16669C5.88287 4.16669 4.16663 5.88293 4.16663 8.00002C4.16663 10.1171 5.88287 11.8334 7.99996 11.8334C10.117 11.8334 11.8333 10.1171 11.8333 8.00002C11.8333 5.88293 10.117 4.16669 7.99996 4.16669Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M3.63957 2.93239C3.4443 2.73713 3.12772 2.73713 2.93246 2.93239C2.73719 3.12766 2.73719 3.44424 2.93246 3.63951L3.40386 4.11091C3.59913 4.30617 3.91571 4.30617 4.11097 4.11091C4.30623 3.91565 4.30623 3.59906 4.11097 3.4038L3.63957 2.93239Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M15.1667 8C15.1667 8.27613 14.9428 8.5 14.6667 8.5H14C13.7239 8.5 13.5 8.27613 13.5 8C13.5 7.72387 13.7239 7.5 14 7.5H14.6667C14.9428 7.5 15.1667 7.72387 15.1667 8Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M13.0677 3.63951C13.2629 3.44424 13.2629 3.12766 13.0677 2.9324C12.8724 2.73713 12.5558 2.73713 12.3605 2.9324L11.8891 3.4038C11.6939 3.59907 11.6939 3.91565 11.8891 4.11091C12.0844 4.30617 12.401 4.30617 12.5963 4.11091L13.0677 3.63951Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M8 13.5C8.27613 13.5 8.5 13.7239 8.5 14V14.6667C8.5 14.9428 8.27613 15.1667 8 15.1667C7.72387 15.1667 7.5 14.9428 7.5 14.6667V14C7.5 13.7239 7.72387 13.5 8 13.5Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M12.5962 11.8891C12.4009 11.6938 12.0844 11.6938 11.8891 11.8891C11.6939 12.0843 11.6939 12.4009 11.8891 12.5962L12.3605 13.0676C12.5558 13.2629 12.8723 13.2629 13.0676 13.0676C13.2629 12.8723 13.2629 12.5557 13.0676 12.3605L12.5962 11.8891Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M2.50004 8C2.50004 8.27613 2.27618 8.5 2.00004 8.5H1.33337C1.05723 8.5 0.833374 8.27613 0.833374 8C0.833374 7.72387 1.05723 7.5 1.33337 7.5H2.00004C2.27618 7.5 2.50004 7.72387 2.50004 8Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
            <path
              d="M4.11085 12.5962C4.30611 12.4009 4.30611 12.0843 4.11085 11.8891C3.91558 11.6938 3.599 11.6938 3.40374 11.8891L2.93233 12.3605C2.73707 12.5557 2.73707 12.8723 2.93233 13.0676C3.12759 13.2629 3.44418 13.2629 3.63944 13.0676L4.11085 12.5962Z"
              fill={mode === "dark" ? "white" : "#1A509B"}
            />
          </g>
          <defs>
            <clipPath id="clip0_18_410">
              <rect fill="white" height="16" width="16" />
            </clipPath>
          </defs>
        </svg>
      </IconButton>
      <IconButton
        size="small"
        sx={{
          padding: "4px",
          backgroundColor: mode === "dark" ? "#353944" : "transparent",
          boxShadow:
            mode === "dark" ? "0px 1px 4px rgba(0, 0, 0, 0.1)" : "none",
          borderRadius: "4px",
          opacity: mode === "dark" ? 1 : 0.6,
          "&:hover": {
            backgroundColor:
              mode === "dark"
                ? "rgba(26, 80, 155, 0.6)"
                : "rgba(255, 255, 255, 0.08)",
          },
        }}
        onClick={toggleTheme}
      >
        <svg
          fill="none"
          height="20"
          viewBox="0 0 16 16"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00004 2.33331C4.87043 2.33331 2.33337 4.87037 2.33337 7.99998C2.33337 11.1296 4.87043 13.6666 8.00004 13.6666C10.9451 13.6666 13.3651 11.4202 13.6406 8.54711C13.6534 8.41345 13.5847 8.28511 13.4664 8.22158C13.348 8.15811 13.203 8.17185 13.0988 8.25651C12.5256 8.72158 11.7958 8.99998 11 8.99998C9.15911 8.99998 7.66671 7.50758 7.66671 5.66665C7.66671 4.57325 8.19284 3.6028 9.00711 2.99443C9.11477 2.91399 9.16357 2.77675 9.13091 2.64639C9.09824 2.51602 8.99051 2.41802 8.85764 2.39783C8.57777 2.35533 8.29137 2.33331 8.00004 2.33331Z"
            fill={mode === "dark" ? "white" : "#1A509B"}
          />
        </svg>
      </IconButton>
    </Box>
  );
};

export default ThemeSwitcher;
